import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources } from './local';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('user_lang') || 'ro',
    fallbackLng: 'ro',
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;